module.exports = __webpack_public_path__ + "static/media/amulet_08.5cac500e.png";